import React, { Suspense, startTransition } from 'react';
import { Routes, Route } from 'react-router-dom';
import './assets/css/custom.css';
import { useNetworkState } from 'react-use';
import { useSelector } from 'react-redux';
import CircularProgressBar from './components/CircularProgress';

const Nointernet = React.lazy(() => import("./components/Nointernet"));
const Splash = React.lazy(() => import("./components/Splash"));
const Welcome = React.lazy(() => import("./layouts/Welcome"));
const Payment = React.lazy(() => import("./layouts/Payment"));
const Otp = React.lazy(() => import("./layouts/Otp"));
const Number = React.lazy(() => import("./layouts/Number"));
const Activity = React.lazy(() => import('./layouts/Activity'));
const Main = React.lazy(() => import("./layouts/Main"));
const Login = React.lazy(() => import("./layouts/Login"));
const ReferCode = React.lazy(() => import('./layouts/ReferCode'));
const ReferPage = React.lazy(() => import("./layouts/ReferPage"));


const App = () => {
  const network = useNetworkState().online;
  const getThemeFromStore = useSelector((state) => state.themeSlice.theme)

  return (
    <Suspense fallback={<div className='grid place-items-center min-h-[100vh]'>
      {/* <p>Loading...</p> */}
      <CircularProgressBar />
    </div>}>
      <div className={getThemeFromStore}>
        <Nointernet show={network} />
        <Routes>
          <Route path='/' element={<Splash />} />
          <Route path='/welcome' element={<Welcome />} />
          <Route path='/main' element={<Main />} />
          <Route path='/payment' element={<Payment />} />
          <Route path='/otp' element={<Otp />} />
          <Route path='/usernumber' element={<Number />} />
          <Route path='/activity' element={<Activity />} />
          <Route path='/login' element={<Login />} />
          <Route path='/refer' element={<ReferCode />} />
          <Route path='/share-refer' element={<ReferPage />} />
        </Routes>
      </div>
    </Suspense>
  )
}

export default App

